/**
 * KDS Search — design spec.
 *
 * Heights are handled by the shared `input` recipe via the `size` prop (sm=32, md=40, lg=48).
 * Icon sizes per design spec:
 * - sm: 16px icon in 20px box
 * - md/lg: 20px icon in 24px box
 */

export const searchSizes = ['sm', 'md', 'lg'] as const;
export type SearchSize = (typeof searchSizes)[number];

export const searchDefaultSize: SearchSize = 'sm';

export const searchIconSizes: Record<SearchSize, number> = {
  sm: 16,
  md: 20,
  lg: 20,
};

export const searchIconBoxSizes: Record<SearchSize, number> = {
  sm: 20,
  md: 24,
  lg: 24,
};

export const searchContainerPadPx = 8;
export const searchGapPx = 4;
